import { toast } from "react-toastify";
import { AxiosError } from "axios";
import {
  InvalidateQueryFilters,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { MAG_HOME_END_POINTS } from "core/constants/endpoints";
import instance from "core/constants/request";
import { ErrorDTO } from "interface";
import { addArticleToArticleLineForm } from "../../type";

const addArticleToArticleLine = async (data: addArticleToArticleLineForm) => {
  const res = await instance.post(
    MAG_HOME_END_POINTS.add_article_line_article,
    data
  );

  return res.data;
};

export const useAddArticleToArticleLine = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [
      MAG_HOME_END_POINTS.add_article_line,
      MAG_HOME_END_POINTS.article_lines_list,
    ],
    mutationFn: addArticleToArticleLine,
    onError: (e: AxiosError<ErrorDTO>) => {
      console.error(e);
      toast.error(
        `${e.response?.data.Message || "خطا در افزودن مقاله به لاین"}`
      );
    },
    onSuccess: () => {
      toast.success(`مقاله با موفقیت به لاین افزوده شد`);
      queryClient.invalidateQueries([
        MAG_HOME_END_POINTS.article_line_articles_list,
      ] as InvalidateQueryFilters);
    },
  });
};
